/* WRJ Snowdrops – custom behaviour */
(function () {
  // Genus, species and subspecies names to show in italics (cultivar names in quotes stay upright)
  var NAMES = [
    'Galanthus', 'reginae-olgae', 'bursanus', 'elwesii', 'nivalis', 'plicatus', 'gracilis',
    'peshmenii', 'valentinei', 'byzantinus', 'vernalis', 'woronowii', 'ikariae', 'alpinus',
    'krasnovii', 'rizehensis', 'lagodechianus', 'fosteri', 'cilicicus', 'koenenianus', 'trojanus'
  ];
  var pattern = new RegExp('(^|[^A-Za-z\\-])(' + NAMES.join('|').replace(/-/g, '\\-') + '|G\\.)(?=$|[^A-Za-z\\-])', 'g');

  // Where product titles appear: product page, product cards, cart, search
  // plus menu sub-headings and collection page titles
  var SELECTORS = [
    '.product__title h1', '.product__title h2', '.product__title a',
    '.card__heading', '.card__heading a',
    '.cart-item__name', '.cart-notification-product__name',
    '.predictive-search__item-heading', '.product-popup-modal__content-info h1',
    '.header__submenu .header__menu-item', '.menu-drawer__menu-item', '.menu-drawer__close-button',
    '.mega-menu__link', '.collection-hero__title', '.collection-list .card__heading'
  ];

  function italicise(el) {
    if (!el || el.dataset.wrjSci) return;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      if (node.parentNode && node.parentNode.closest && node.parentNode.closest('em, i')) return;
      var text = node.nodeValue;
      // Ignore anything inside a cultivar name in quotes
      if (!pattern.test(text)) return;
      pattern.lastIndex = 0;
      var frag = document.createDocumentFragment();
      var parts = text.split(/('[^']*'|‘[^’]*’)/);
      parts.forEach(function (part) {
        if (/^('|‘)/.test(part)) {
          frag.appendChild(document.createTextNode(part));
          return;
        }
        var last = 0;
        part.replace(pattern, function (match, pre, name, offset) {
          var start = offset + pre.length;
          frag.appendChild(document.createTextNode(part.slice(last, start)));
          var em = document.createElement('em');
          em.className = 'wrj-sci';
          em.textContent = name;
          frag.appendChild(em);
          last = start + name.length;
          return match;
        });
        frag.appendChild(document.createTextNode(part.slice(last)));
      });
      node.parentNode.replaceChild(frag, node);
    });
    el.dataset.wrjSci = '1';
  }

  // Never split hyphenated words (e.g. 'garden-worthy', 'reginae-olgae') across two lines
  var HYPHENATED = /[A-Za-z0-9À-ɏ'’]+(?:[-‐‑][A-Za-z0-9À-ɏ'’]+)+/g;
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1, OPTION: 1, NOSCRIPT: 1, svg: 1 };
  function keepHyphensTogether(root) {
    root = root || document.body;
    if (!root || root.nodeType !== 1 || SKIP[root.nodeName]) return;
    if (root.classList && root.classList.contains('wrj-nowrap')) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode;
        if (!p || SKIP[p.nodeName] || (p.closest && p.closest('.wrj-nowrap, script, style, textarea'))) return NodeFilter.FILTER_REJECT;
        return /[-‐‑]/.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var text = node.nodeValue;
      HYPHENATED.lastIndex = 0;
      if (!HYPHENATED.test(text)) return;
      HYPHENATED.lastIndex = 0;
      var frag = document.createDocumentFragment();
      var last = 0, m;
      while ((m = HYPHENATED.exec(text)) !== null) {
        frag.appendChild(document.createTextNode(text.slice(last, m.index)));
        var span = document.createElement('span');
        span.className = 'wrj-nowrap';
        span.textContent = m[0];
        frag.appendChild(span);
        last = m.index + m[0].length;
      }
      frag.appendChild(document.createTextNode(text.slice(last)));
      node.parentNode.replaceChild(frag, node);
    });
  }

  function run(root) {
    (root || document).querySelectorAll(SELECTORS.join(',')).forEach(italicise);
    keepHyphensTogether(root && root.nodeType === 1 ? root : document.body);
    // Alternate blog photos left and right
    document.querySelectorAll('.article-template__content img').forEach(function (img, i) {
      if (i % 2 === 1) img.classList.add('wrj-img-left');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); });
  } else {
    run();
  }
  // Re-run when parts of the page are refreshed (filters, cart drawer, search)
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (n) { if (n.nodeType === 1 && !(n.classList && (n.classList.contains('wrj-nowrap') || n.classList.contains('wrj-sci')))) run(n); });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
